import * as type from '../types';
import { RequestState } from './RequestState';

const INITIAL_STATE = {
  sites: {},
  allSites:{},
  site: {},
  error: {},
  requestStatus: RequestState.EMPTY,
  loading: false,
  exportAllLoading:false
};

const reducer =  (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.SITES_FETCH_REQUEST:
      return {
        ...state,
        error: {},
        sites: {},
        loading: true
      };
    case type.SITES_FETCH_SUCCESS:
      return {
        ...state,
        sites: action.payload,
        loading: false
      };
    case type.SITES_FETCH_FAILURE:
      return {
        ...state,
        sites: {},
        loading: false
      };
      case type.ALL_SITES_FETCH_REQUEST:
      return {
        ...state,
        error: {},
        allSites: {},
        exportAllLoading: true
      };
    case type.ALL_SITES_FETCH_SUCCESS:
      return {
        ...state,
        allSites: action.payload,
        exportAllLoading: false
      };
    case type.ALL_SITES_FETCH_FAILURE:
      return {
        ...state,
        allSites: {},
        exportAllLoading: false
      };
      case type.SITE_SAVE_REQUEST:
        return {
          ...state,
          error: {},
          site: {},
          requestStatus: RequestState.PENDING,
        };
    case type.SITE_SAVE_SUCCESS:
      return {
        ...state,
        site: action.payload,
        error: {},
        requestStatus: RequestState.SUCCESS,
      };
    case type.SITE_SAVE_FAILURE:
      return {
        ...state,
        site: {},
        error: action.payload,
        requestStatus: RequestState.FAILURE,
      };
      case type.SITE_DELETE_REQUEST:
        return {
          ...state,
          requestStatus: RequestState.PENDING,
        };
        case type.SITE_DELETE_SUCCESS:
          return {
            ...state,
            site: action.payload,
            error: {},
            requestStatus: RequestState.SUCCESS,
          };
        case type.SITE_DELETE_FAILURE:
          return {
            ...state,
            site: {},
            error: action.payload,
            requestStatus: RequestState.FAILURE,
          };
          case type.CLEAN_REQUEST_STATUS:
            return {
              ...state,
              requestStatus: RequestState.EMPTY
            };
    default:
      return state;
  }
};


export default reducer;